import './DownloadsGrid.scss'
import DownloadDataCard, { DownloadDataItem } from '../DownloadDataCard/DownloadDataCard.component'
import { Instalation } from '../../../utils/models/Instalation'
import { Machine } from '../../../utils/models/Machine'
import { ISelectOptions } from 'aw-combobox'
import { useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'

const DownloadsGrid = (props: { loading: boolean, sent: boolean, installations: Instalation[], machines: Machine[], fileName?: string, category?: string, uploadedFile?: string, date?: string, version?: string, selectedInstallation?: ISelectOptions, selectedMachine?: ISelectOptions }) => {

  const [downloadableListItems, setDownloadableListItems] = useState<DownloadDataItem[]>([])

  const downloadData: DownloadDataItem = {
    fileName: 'Machine Guide',
    category: 'Guides',
    version: '1.5.7',
    date: '04/01/2025',
    uploadedFile: 'machine_user_guide.pdf',
    installation: props.installations[0]?.name || '',
    machine: props.machines[0]?.name || ''
  };
  const downloadData2: DownloadDataItem = {
    fileName: 'User Manual',
    category: 'Manuals',
    version: '3.2b',
    date: '07/01/2025',
    uploadedFile: 'user_manual_model_3b.pdf',
    installation: props.installations[0]?.name || ''
  };
  const downloadData3: DownloadDataItem = {
    fileName: 'Machine Errors List',
    category: 'Errors',
    version: '2.3.1',
    date: '02/01/2025',
    uploadedFile: 'machine_failures_list.csv'
  };

  useEffect(() => {
    setDownloadableListItems([downloadData, downloadData2, downloadData3])
    console.log("setter llista executat")
  }, [props.installations, props.machines])

  useEffect(() => {
    if (props.sent) {
      const downloadDataLoaded: DownloadDataItem = {
        fileName: props.fileName ? props.fileName : 'Uploaded File',
        category: props.category ? props.category : 'Other',
        version: props.version ? props.version : '1.0',
        date: props.date ? formatDate(props.date) : '07/01/2025',
        installation: props.selectedInstallation ? props.selectedInstallation.label : '',
        machine: props.selectedMachine?.label ?? undefined,
        uploadedFile: 'machine_failures_list.csv'
      };
      console.log("Array: ",downloadableListItems)
      setDownloadableListItems(prevItems => [downloadDataLoaded, ...prevItems])
    }
  }, [props.sent])

  const formatDate = (date: string): string => {
    const [year, month, day] = date.split("-")
    return `${day}/${month}/${year}`
  }


  return (
    <div id="downloads-container" className="text-center rounded-1 p-3">
      <div className='scrolleable-div mt-2'>
        <div className='col'>
          {props.loading ? (
            <div className="text-center pt-5">
              <Spinner animation="border" variant="success" />
            </div>
          ) : (
            downloadableListItems.map((d: DownloadDataItem, index: number) => (
              <div className="row mt-2" key={index}>
                <DownloadDataCard downloadData={d}></DownloadDataCard>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  )
}

export default DownloadsGrid